import React from 'react';

import Toast from 'nav/toasts/Toast';
import {ToastType} from 'nav/toasts/ToastConstants';
import * as Headers from 'ui-library/Headers';

export default function ToastGuidelines(): JSX.Element {
  return (
    <div className="u-spacing">
      <Headers.Header1>Toasts</Headers.Header1>
      <div>
        <a href="https://projects.invisionapp.com/d/main#/console/13433387/356399431/preview">
          https://projects.invisionapp.com/d/main#/console/13433387/356399431/preview
        </a>
      </div>
      <div>
        <code>nav/toasts/Toast.tsx</code>
      </div>
      {[
        {
          type: ToastType.INFO,
          message:
            'Experiencing some issues while saving your entry “Untitled” -- working to resolve them...',
        },
        {
          type: ToastType.INFO,
          message: 'A newer version of Benchling is available.',
          actionText: 'Refresh',
        },
        {
          type: ToastType.SUCCESS,
          message: 'You’ve successfully completed all getting started tasks and earned an additional 1GB!',
        },
        {
          type: ToastType.WARNING,
          message: 'Your entry could not be saved. Check your internet connection or trying refreshing.',
          actionText: 'Refresh',
        },
        {
          type: ToastType.DANGER,
          message: 'Your request could not be completed.',
        },
      ].map(({type, actionText, message}, index) => (
        <div className="u-small-spacing-top">
          <Toast
            message={message}
            type={type}
            actionText={actionText}
            isCloseable={true}
            onActionClick={() => {}}
            id={index}
          />
        </div>
      ))}
    </div>
  );
}
